import React from "react";
import { Flex, Text, Input } from "components-lib";
import ClinicDoctorSelector from 'components/ClinicDoctorSelector/ClinicDoctorSelector';

/**
 * ConsultationFilters Component
 * Handles the filter controls for consultations view
 * Includes doctor selection, date range filters
 */
const ConsultationFilters = ({
  isOwner,
  isAdmin,
  isDoctor,
  doctors,
  selectedDoctor,
  setSelectedDoctor,
  selectedClinic,
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
  onClinicSelect,
  useGlobal = true // if true, suppress internal controls (global bar handles them)
}) => {
  return (
    <Flex gap={4} align="center" minW={{ base: "100%", xl: "auto" }}>
      {/* If not using global filters, render local clinic/doctor selector */}
      {!useGlobal && (isOwner || isAdmin) && !isDoctor && (
        <ClinicDoctorSelector
          isAdmin={isAdmin}
          isOwner={isOwner}
          clinicId={selectedClinic}
          initialDoctorId={selectedDoctor}
          onClinicSelect={(clinicId) => {
            if (typeof onClinicSelect === 'function') onClinicSelect(clinicId);
            setSelectedDoctor('');
          }}
          onDoctorSelect={(docId) => setSelectedDoctor(docId)}
        />
      )}

      {!useGlobal && (
        <Flex align="center" gap={2}>
          <Text fontWeight="medium" whiteSpace="nowrap">From:</Text>
          <Input
            type="date"
            value={fromDate}
            onChange={onFromDateChange}
            size="md"
            width="150px"
            bg="white"
          />
        </Flex>
      )}

      {!useGlobal && (
        <Flex align="center" gap={2}>
          <Text fontWeight="medium" whiteSpace="nowrap">To:</Text>
          <Input
            type="date"
            value={toDate}
            onChange={onToDateChange}
            size="md"
            width="150px"
            bg="white"
          />
        </Flex>
      )}
    </Flex>
  );
};

export default ConsultationFilters;